var map = {
	"./aws-cci-1.png": "83b5",
	"./aws-cci-2.png": "f57a",
	"./aws-cci-3.png": "8b83",
	"./aws-cci-4.png": "aaa2",
	"./aws-cci-5.png": "ab73",
	"./aws-cci-6.png": "db27",
	"./aws-cci-7.png": "928c",
	"./logo-nexmo-dark.png": "a9fe",
	"./logo_vonage-light.png": "7d11",
	"./nexmo-logo-collapsed.png": "8dbc",
	"./nexmo-logo-w-vonage.png": "fd6c",
	"./nids-logo.png": "eaa4",
	"./vids-logo.png": "18bc",
	"./vids-logo2.png": "b491",
	"./vids-logo3.png": "fefc",
	"./vonage-logo-collapsed.png": "0404"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";